import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App, { AppLayout } from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Contact from './contact/Contact';
import Blogs from './blogs/Blogs';
import BlogsRecent from './blogs/BlogsRecent';
import BlogCategory from './blogs/BlogCategory';
import BlogDetails from './blogs/BlogDetails';
import BlogNew from './blogs/BlogNew';
import Projects from './projects/Projects';
import OpenAI from './projects/openai/OpenAI';
import About from './about/About';
import BlogsTimeline from './blogs/BlogsTimeline';
import ThankYou from './special/ThankYou';

let alreadyVisited = sessionStorage.getItem('dmlzaXRlZA==');
if (!alreadyVisited) {
  fetch(process.env.REACT_APP_IP_API_URL).then(response => {
    if (response.ok) {
      response.text().then(value => {
        let userInfo = {}
        userInfo.currIp = value;

        const requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(userInfo)
        };

        fetch(process.env.REACT_APP_USER_API_URL, requestOptions)
          .then(response => {
            if (response.ok) {
              sessionStorage.setItem('dmlzaXRlZA==', true);
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    } else {
      console.log('ipLoc status: ' + response.status);
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route element={<AppLayout />}>
        <Route path="/" element={<App />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/openai" element={<OpenAI />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/new" element={<BlogNew />} />
        <Route path="/blogs/:category" element={<BlogCategory />} />
        <Route path="/blogs/:category/:slug" element={<BlogDetails />} />
        <Route path="/latestblogs" element={<BlogsRecent />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/blogs-timeline" element={<BlogsTimeline />} />
        <Route path="/thankyou/mchimirev" element={<ThankYou />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
